import { render, staticRenderFns } from "./AssessmentUserTypeSelect.vue?vue&type=template&id=c1b440e8&"
import script from "./AssessmentUserTypeSelect.vue?vue&type=script&lang=js&"
export * from "./AssessmentUserTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports